import admin from "./nl/admin.json";
import common from "./nl/common.json";
import error from "./nl/error.json";
import groups from "./nl/groups.json";
import library from "./nl/library.json";
import userLogin from "./nl/userLogin.json";
import users from "./nl/users.json";
import media from "./nl/media.json";
import categories from "./nl/categories.json";
import tags from "./nl/tags.json";
import fileDropZone from "./nl/fileDropZone.json";
import client from "./nl/client.json";
import comments from "./nl/comments.json";
import news from "./nl/news.json";
import roles from "./nl/roles.json";
import zones from "./nl/zones.json";
import contacts from "./nl/contacts.json";
import accreditation from "./nl/accreditation.json";
import help from "./nl/help.json";
import profile from "./nl/profile.json";
import reports from "./nl/reports.json";
import notifications from "./nl/notifications.json";
import feedback from "./nl/feedback.json";
import assets from "./nl/assets.json";
import widgets from "./nl/widgets.json";
import recordLock from "./nl/recordLock.json";
import settings from "./nl/settings.json";
import tenants from "./nl/tenants.json";
import apps from "./nl/apps.json";
import favourites from "./nl/favourites.json";
import fragments from "./nl/fragments.json";
import links from "./nl/links.json";
import tiptap from "./nl/tiptap.json";
import videoPlayer from "./nl/videoPlayer.json";
import audioPlayer from "./nl/audioPlayer.json";
import search from "./nl/search.json";
import decisionTrees from "./nl/decisionTrees.json";
import forms from "./nl/forms.json";
import schematics from "./nl/schematics.json";
import dialogs from "./nl/dialogs.json";
import nlvManager from "./nl/nlvmanager.json";
import glossary from "./nl/glossary.json";

export const nl = {
  common: common,
  userLogin: userLogin,
  admin: admin,
  error: error,
  groups: groups,
  users: users,
  media: media,
  tags: tags,
  categories: categories,
  fileDropZone: fileDropZone,
  library: library,
  client: client,
  comments: comments,
  news: news,
  roles: roles,
  zones: zones,
  contacts: contacts,
  accreditation: accreditation,
  help: help,
  profile: profile,
  reports: reports,
  notifications: notifications,
  feedback: feedback,
  assets: assets,
  widgets: widgets,
  recordLock: recordLock,
  settings: settings,
  tenants: tenants,
  apps: apps,
  favourites: favourites,
  fragments: fragments,
  links: links,
  tiptap: tiptap,
  videoPlayer: videoPlayer,
  audioPlayer: audioPlayer,
  search: search,
  decisionTrees: decisionTrees,
  forms: forms,
  dialogs: dialogs,
  schematics: schematics,
  nlvManager: nlvManager,
  glossary: glossary,
};
